import {
  AfterViewInit,
  DOCUMENT,
  Directive,
  ElementRef,
  EventEmitter,
  HostBinding,
  Inject,
  Input,
  OnDestroy,
  Output,
  Renderer2
} from '@angular/core';

import { Subscription, fromEvent } from 'rxjs';
import { filter } from 'rxjs/operators';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[overlay]',
  standalone: false
})
export class OverlayDirective implements AfterViewInit, OnDestroy {
  @Output() onClickOuside = new EventEmitter<void>();
  @Input() set activeOverlay(value: boolean) {
    this._activeOverlay = value;
  }
  get activeOverlay(): boolean {
    return this._activeOverlay;
  }
  private _activeOverlay: boolean;
  private _body: HTMLElement;
  private _documentClickSubscription: Subscription | undefined;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private elementRef: ElementRef<HTMLElement>,
    private renderer: Renderer2
  ) {
    this._body = this.document.body;
  }

  @HostBinding('class.overlay-panel--active') get addActiveClass(): boolean {
    return this.activeOverlay;
  }

  ngOnDestroy(): void {
    this._documentClickSubscription?.unsubscribe();
  }

  ngAfterViewInit(): void {
    this._documentClickSubscription = fromEvent(
      this.elementRef.nativeElement,
      'click'
    )
      .pipe(
        filter(() => !!this.elementRef?.nativeElement && this.activeOverlay)
      )
      .subscribe(() => this.onClickOuside.emit());
  }
}
